import React from 'react';
import styled from 'styled-components';
import { SearchLayoutProps } from './types';

const SIDEBAR_MIN_WIDTH = 174;

export { SIDEBAR_MIN_WIDTH };

const OuterContainer = styled.div<{ $isProductsPage: boolean }>`
  display: flex;
  height: 100%;
  padding-top: 20px;
  gap: 16px;
  overflow-y: auto;
  align-items: flex-start;
  ${({ $isProductsPage }) =>
    $isProductsPage &&
    `
    background-color: #edf2f4;
    padding: 16px;
    margin-top: 16px;
    margin-left: -16px;
  `}
`;

const SidebarContainer = styled.div<{ $top: number }>`
  min-width: ${SIDEBAR_MIN_WIDTH}px;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 24px;
  position: sticky;
  top: ${({ $top }) => $top}px;
  z-index: 1;
`;

const ContentColumn = styled.div`
  flex: 3;
`;

const SearchLayout: React.FC<SearchLayoutProps> = ({
  sidebar,
  content,
  isProductsPage = false,
  sidebarTop = 0,
  sidebarRef,
  containerRef,
}) => (
  <OuterContainer ref={containerRef} $isProductsPage={isProductsPage}>
    <SidebarContainer ref={sidebarRef} $top={sidebarTop}>
      {sidebar}
    </SidebarContainer>
    <ContentColumn>
      {content}
    </ContentColumn>
  </OuterContainer>
);

export default SearchLayout;
